import data from "@/assets/data/course.json";

class Course {
  constructor(data){
    this.data = data;
  }
  getCourse(id){
    const data = this.data;
    for(let k of Object.keys(data)) {
      if( k === id ){
        return data[k];
      }
    }
  }
}
export default new Course(data);